import React, { useState } from 'react';
import AdminPanel from './AdminPanel';
import '../admin.css';

export default function AdminButton({ config, updateConfig }) {
  const [phase, setPhase] = useState('closed'); // closed | password | open
  const [passwordInput, setPasswordInput] = useState('');
  const [error, setError] = useState('');

  const handlePasswordSubmit = (e) => {
    e.preventDefault();
    if (passwordInput === config.adminPassword) {
      setPasswordInput('');
      setError('');
      setPhase('open');
    } else {
      setError('Contraseña incorrecta');
    }
  };

  const handleClose = () => {
    setPhase('closed');
    setPasswordInput('');
    setError('');
  };

  return (
    <>
      <button className="admin-btn" onClick={() => setPhase('password')} title="Administración">
        ⚙️
      </button>

      {phase === 'password' && (
        <div className="admin-password-overlay">
          <form className="admin-password-modal" onSubmit={handlePasswordSubmit}>
            <h3>🔒 Acceso Admin</h3>
            <input
              type="password"
              placeholder="Contraseña"
              value={passwordInput}
              onChange={(e) => setPasswordInput(e.target.value)}
              autoFocus
            />
            {error && <p className="admin-password-error">{error}</p>}
            <div className="admin-password-actions">
              <button type="button" className="btn-cancel" onClick={handleClose}>Cancelar</button>
              <button type="submit" className="btn-enter">Entrar</button>
            </div>
          </form>
        </div>
      )}

      {phase === 'open' && (
        <AdminPanel config={config} updateConfig={updateConfig} onClose={handleClose} />
      )}
    </>
  );
}
